import UserDetails from 'components/admin/Users/UserDetails'
import React from 'react'

import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { initialize } from 'redux-form'
import { cancelConfirm } from 'redux/navigation'
import { loadImportUser, loadUsers } from 'redux/userAdmin'

const mapStateToProps = (state, ownProps) => {
  const { importUserLoading, importUser = {} } = state.userAdmin
  return { importUserLoading, importUser }
}

const mapDispatchToProps = (dispatch) => {
  return bindActionCreators(
    {
      cancelConfirm,
      loadImportUser,
      loadUsers,
      initialize,
    },
    dispatch
  )
}

class DealerImportContainer extends React.Component {
  componentWillMount() {
    const {
      match: { params: params = {} },
    } = this.props // react router
    const { loadImportUser, loadUsers } = this.props
    loadUsers()
    if (params.dealer_id) loadImportUser(params.dealer_id)
  }

  componentWillReceiveProps(nextProps) {
    const { importUserLoading: importUserLoadingOld, initialize } = this.props
    const {
      importUserLoading: importUserLoadingNew,
      importUser: importUserNew = {},
    } = nextProps

    if (
      importUserLoadingOld === true &&
      importUserLoadingNew === false &&
      importUserNew.id
    ) {
      const {
        address1,
        address2,
        address6,
        postcode,
        place,
        email,
        discount1,
        discount2,
        discount3,
        kind,
        payment_terms,
        address_number,
        address_type,
      } = importUserNew
      initialize('dealer_import_form', {
        status: 'active',
        prepayment: false,
        addresses: [],
        user_type: kind === 'Filiale' ? 'shop' : 'dealer',
        address_type,
        address1,
        address2,
        address6,
        postcode,
        place,
        email,
        discount1,
        discount2,
        discount3,
        kind,
        payment_terms,
        address_number,
      })
    }
  }

  render() {
    const { importUser = {} } = this.props
    return (
      <UserDetails importUsers form="dealer_import_form" dealer={importUser} />
    )
  }
}

DealerImportContainer = connect(mapStateToProps, mapDispatchToProps)(
  DealerImportContainer
)
export default DealerImportContainer



// WEBPACK FOOTER //
// ./src/containers/admin/dealer_import.jsx